var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    width: 42,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 801.787737c0 107.787661 92.888119 223.570702 230.061131 222.200213h570.123392c124.274901 0 223.803427-107.368757 223.803427-223.99995V224.8119C1023.98795 108.072102 927.888232 0 795.545547 0H225.018766C93.151874 0 0 111.397477 0 224.8119v576.975837z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M620.097107 0H225.018766C93.151874 0 0 111.397477 0 224.8119v91.450399l620.097107 0.584397V0z",
    fill: "#AFE881"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M697.206503 1023.98795h102.972848c124.274901 0 223.808599-107.368757 223.808599-223.99995V796.435072h-325.814348l-0.967099 227.552878z",
    fill: "#A3CAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 408.560849V315.471035h1023.98795v93.089814z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M620.097107 1023.998293V0h78.102354v1023.998293z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 796.435072v-124.119751h1023.98795v124.119751z",
    fill: "#FFDF48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M206.866253 1023.998293V0h155.149689v1023.998293z",
    fill: "#FFCF68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.463064 536.911015l73.411662 116.103684 3.201255-101.002447z",
    fill: "#D6D7D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.874726 653.014699l132.125475 208.965945 23.086274 2.482395v-280.122764l-155.211749-34.148446z",
    fill: "#E5BA5E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M392.663177 796.435072h209.545171l-141.263792-62.059876z",
    fill: "#E4C84A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M362.776175 864.426838l253.281868 27.213255-0.630942-97.692587H363.086475z",
    fill: "#D6D7D4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M616.058043 891.640093l91.957221 9.877864L615.427101 793.952677z",
    fill: "#E7E7E8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M890.936748 186.179627L318.780895 664.216507l21.219306 197.764137 60.472177-157.616569z",
    fill: "#0066BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M391.106509 702.884981l-51.106308 159.095663 120.944355-116.243319L419.814373 672.315321z",
    fill: "#014E9D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.463064 536.911015l184.317831 127.305492L890.936748 186.179627l-500.440495 513.690279 317.519011 201.648051L890.936748 186.179627z",
    fill: "#0093FD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.552138f67b47aa2ff9779e6ffc2abeed.svg";
export { ForwardRef as ReactComponent };